import { UserData } from '@riise/shared/utils/constants/users';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Apollo } from "apollo-angular";
import { Router } from '@angular/router';


import { CryptoService } from '@riise/core/services/crypto/crypto.service';
import { getMenuByRole } from '../menu/menu';
import { PermissionService } from '../permission/permission.service';


export interface Menu {
	headTitle?: string,
	headTitle2?: string,
	path?: string;
	title?: any;
	icon?: string;
	type?: string;
	badgeValue?: string;
	badgeClass? :string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
	Menusub?: boolean;
	target?:boolean
}

@Injectable({
	providedIn: 'root'
})

export class NavService implements OnDestroy {
	private apollo = inject(Apollo);
	private userData = inject(UserData);

	private router = inject(Router);
	private permissionService = inject(PermissionService);


	private unsubscriber: Subject<any> = new Subject();
	public  screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

	// Search Box
	public search: boolean = false;

	// Language
	public language: boolean = false;

	// Mega Menu
	public megaMenu: boolean = false;
	public levelMenu: boolean = false;
	public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

	// Collapse Sidebar
	public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

	// For Horizontal Layout Mobile
	public horizontal: boolean = window.innerWidth < 991 ? false : true;

	// Full screen
	public fullScreen: boolean = false;

    // User space & roleName
    public space: any = Number(this.userData?.space);
    public roleName: any = String(this.userData?.roleName);

    MENUITEMS: Menu[] = [];
    items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

	/** Inserted by Angular inject() migration for backwards compatibility */




	constructor() {

        this.setScreenWidth(window.innerWidth);
		fromEvent(window, 'resize').pipe(debounceTime(1000),
		takeUntil(this.unsubscriber)
		).subscribe((evt: any) => {
			this.setScreenWidth(evt.target.innerWidth);
			if (evt.target.innerWidth < 991) {
				this.collapseSidebar = true;
				this.megaMenu = false;
				this.levelMenu = false;
			}
			if(evt.target.innerWidth < 1199) {
				this.megaMenuColapse = true;
			}
		});


		if(window.innerWidth < 991) {
			this.router.events.subscribe(event => {
				this.collapseSidebar = true;
				this.megaMenu = false;
				this.levelMenu = false;
			});
		}


		// 1: administrator, 2: broker, 3 et 4: provider, 5 et 6: client, 7: insurer, 8: visitor
		localStorage.removeItem('NoahorizontalHover')
        this.MENUITEMS = getMenuByRole(this.roleName, this.space, this.permissionService);
		this.items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

	}


	menuHorizontal() {
		localStorage.setItem('NoahorizontalHover', 'true')
		localStorage.removeItem('Noahorizontal')
		localStorage.removeItem('NoasidebarMini')
		document.querySelector('body')?.classList.add('color-menu');
	}


	menuVertical() {
		localStorage.removeItem('NoahorizontalHover')
	}



	ngOnDestroy() {
		this.unsubscriber.next;
		this.unsubscriber.complete();
	}


	private setScreenWidth(width: number): void {
		this.screenWidth.next(width);
	}


}


